export default {"src":"/_next/static/media/brush_64.c397912f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};